<template>
    <section class="reviews container">
        <h2 class="reviews-heading text-uppercase">
            Reviews ({{ reviewCount }})
        </h2>
        <template v-if="reviewCount">
            <div class="reviews-container">
                <single-review
                v-for="review in reviews.data"
                :review="review"
                :key="review.id" />
            </div>
            <mugen-scroll :handler="loadMoreReviews" :should-handle="!isLoadingReviews">
                <template v-if="reviews.total_pages != page">
                    <img class="spinner" src="/assets/spinner-black.svg" title="Loading reviews..." />
                </template>
            </mugen-scroll>
        </template>
        <div v-else>
            <div class="no-reviews-container">
                <p>There are no reviews for this PC yet.</p>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SingleReview from "./single-review";
import MugenScroll from "vue-mugen-scroll"

export default {
    name: "StarterPcReviews",
    components: {
        SingleReview,
        MugenScroll
    },
    computed: {
        ...mapState({
            reviews: state => state.StarterPc.reviews,
            isLoadingReviews: state => state.StarterPc.isLoadingReviews,
            page: state => state.StarterPc.page,
            builds: state => state.StarterPc.builds,
            buildsIndex: state => state.StarterPc.buildsIndex,
        }),
        ...mapGetters({
            reviewCount: "StarterPc/reviewCount"
        }),
        hasRemainingReviews() {
            return this.reviews.total_pages >= this.page + 1;
        }
    },
    methods: {
        loadMoreReviews() {
            if (this.hasRemainingReviews) {
                this.$store.dispatch("StarterPc/setPage", this.page + 1);
                this.$store.dispatch("StarterPc/getReviews");
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.reviews {
    padding-bottom: 50px;
    margin-top: 20px;

    &-heading {
        font-size: 36px;
        text-align: center;
        margin-bottom: 40px;

        @media (max-width: 580px) {
            text-align: left;
        }
    }

    &-container, .no-reviews-container {
        max-width: 720px;
        margin: 0 auto;
    }

    .spinner {
        width: 10%;
        display: block;
        margin: 0 auto;
    }

    .no-reviews-container {
        p {
            font-style: italic;
            font-size: 16px;
            color: #5F707F;
        }
    }
}
</style>

